<template>
  <div>
    <m-form-text
      ref="myinput"
      :id="id"
      :value="rawvalue"
      type="text"
      :name="name"
      :autocomplete="autocomplete"
      :readonly="readonly"
      :disabled="disabled"
      :autoSelectOnFocus="false"
      :label="label"
      :tooltip="tooltip"
      :tooltipPosition="tooltipPosition"
      :rules="rules"
      :placeholder="placeholder"
      :appendIcon="appendIcon"
      :prependIcon="prependIcon"
      :appendText="appendText"
      :prependText="prependText"
      :ariaHaspopup="true"
      @click="onclick"
      @input="oninput"
      @focus="onfocus"
      @keyup="onkeyup"
      @keydown="onkeydown"
      @ShowDropdownMenu="ShowDropdownMenu"
    ></m-form-text>
    <div
      class="dropdown-menu"
      ref="mydropdown"
      v-show="showDropdown"
      style="display:block;"
      @click="onclickDropdown"
    >
      <m-calendar :value="valueInterne" @input="oninputcalendar"></m-calendar>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import MFormBase from "./MFormBase";
import { createPopper } from "@popperjs/core";

export default {
  name: "mformdate",
  // extends: MFormBase,
  props: {
    value: [String, Object],
    id: {
      default: "",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    autocomplete: {
      default: "new-password",
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    autoSelectOnFocus: {
      default: true,
      type: Boolean
    },
    label: {
      default: "",
      type: String
    },
    tooltip: {
      default: "",
      type: String
    },
    tooltipPosition: {
      default: "bottom",
      type: String
    },
    rules: {
      default: function() {
        return [];
      },
      type: Array
    },
    placeholder: String,
    prependIcon: String,
    appendIcon: String,
    prependText: String,
    appendText: String,

    formatInput: {
      default: "DD/MM/YYYY",
      type: String
    },
    formatValue: {
      default: "YYYY-MM-DD",
      type: String
    }
  },
  mounted() {
    if (!this.id2) this.id2 = this.$Utils.randomstring();
    if (this.value) this.setEnterValue(this.value);
    this.$nextTick(() => {
      this.popper = createPopper(
        this.$refs.myinput.$el,
        this.$refs.mydropdown,
        {
          placement: "bottom-start"
        }
      );
    });
  },

  data() {
    // let name2 = this.name ? this.name : "";
    // let valueInterne = this.value ? moment(this.value, this.formatValue) : moment();

    return {
      currentPartFocus: 0,
      id2: this.id,
      // name2,
      valueInterne: moment(),
      // rawvalue: moment().format("DD/MM/YYYY"),
      rawvalue: "",
      errormsg2: "",
      showDropdown: false,
      pos: 0
    };
  },
  watch: {
    // rawvalue: function(val) {
    //   this.$emit("search", val);
    //   if (val == "") this.$emit("input", "");
    // },
    value: function(val) {
      this.setEnterValue(val);
      // this.valueInterne = this.value
      //   ? moment(this.value, this.formatValue)
      //   : moment();
      // this.rawvalue = this.valueInterne.format(this.formatInput);
    }
  },
  components: {},
  methods: {
    _getInput() {
      return this.$refs.myinput.$refs.myinput;
    },
    setEnterValue(v) {
      if (v === "0000-00-00" || v === "") {
        // v = moment().format("DD/MM/YYYY");
        this.valueInterne = "";
        this.rawvalue = "";
        this.$emit("input", "0000-00-00");
        return;
      }
      this.valueInterne = moment.isMoment(v) ? v : moment(v, this.formatValue);
      this.rawvalue = this.valueInterne.format(this.formatInput);
      this.$emit("input", this.valueInterne.format(this.formatValue));
    },
    ShowDropdownMenu(showDropdown) {
      this.showDropdown = showDropdown;
      this.popper.update();
    },
    /* onWindowClick() {
      this.showDropdown = false;
    }, */
    oninput(val) {
      let input = this._getInput();
      if (val === "") {
        this.setEnterValue("");
        return;
      }
      let m = moment(val, this.formatInput, true);
      if (m.isValid()) {
        this.setEnterValue(m);
      }
      this.pos = input.selectionStart;
      // console.log("pos", this.pos);
      if (this.pos == 2) this.whatFocus(1);
      if (this.pos == 5) this.whatFocus(2);
      if (this.pos == 10) this.whatFocus(10);
      // this.rawvalue = val;
    },
    oninputcalendar(val, what) {
      // console.log("oninputcalendar", val);
      this.setEnterValue(moment(val));
      this.showDropdown = false;
      this.popper.update();
      this.whatFocus(2);
      // console.log("this.pos calendar", this.pos);
      // this.valueInterne = moment(val);
      // this.rawvalue = val.format(this.formatInput);
      // this.$emit("input", val.format(this.formatValue));
    },
    onkeyup(evt) {
      this.$emit("keyup", evt);
    },
    onkeydown(evt) {
      if (
        evt.key == "ArrowRight" ||
        evt.key == "ArrowLeft" ||
        evt.key == "Backspace"
      ) {
      } else if (evt.key === "Tab") {
        // console.log("onkeydown", evt.key);
        if (this.pos !== 10) {
          evt.preventDefault();
          this.whatFocus(-1);
        } else {
          this.pos = 0;
        }
      } else if (!Number.isInteger(evt.key * 1)) {
        evt.preventDefault();
      }

      this.$emit("keydown", evt);
    },
    whatFocus(part) {
      // console.log("part", part);

      //part=-1 alors prochain focus
      let input = this._getInput();
      if (part == -1) {
        this.currentPartFocus++;
        if (this.currentPartFocus >= 3) this.currentPartFocus = 0;
        part = this.currentPartFocus;
      }
      if (part == 0) {
        input.selectionStart = 0;
        input.selectionEnd = 2;
      } else if (part == 1) {
        input.selectionStart = 3;
        input.selectionEnd = 5;
      } else if (part == 2) {
        input.selectionStart = 6;
        input.selectionEnd = 10;
      }
    },
    onfocus(evt) {
      this.$emit("focus", evt);
      // this.$refs.mydropdown.style.display = "block";
      // let input = this._getInput();
      this.whatFocus(0);
      this.showDropdown = true;
      this.popper.update();
    },
    onclick(evt) {
      // evt.stopPropagation();
    },
    onclickDropdown(evt) {
      evt.stopPropagation();
    },

    informValid() {
      this.errormsg2 = "";
    },
    informInvalid(txt) {
      this.errormsg2 = txt;
    },
    validate() {
      let oks = [];
      for (let iRule = 0; iRule < this.rules.length; iRule++) {
        const rule = this.rules[iRule];
        let ok = rule(this.valueInterne ? this.valueInterne.value : null);
        if (this.$_.isString(ok)) oks.push(ok);
      }
      if (oks.length == 0) {
        this.informValid();
        return true;
      }
      this.informInvalid(oks.join(","));
      return false;
    }
  }
};
</script>
<style lang="scss"></style>
